module.exports = __webpack_public_path__ + "img/settingsDark.61a8f2af.svg";